import { ChangeEvent, useEffect, useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import './styles.css'
import ActivationGuideCard from "./ActivationGuideCard";
import { getProtocsSolicsBenef } from "../../../services/MinhasGuiasService";
import { Pagination } from "@mui/material";
import { sxPagination } from "../../SaudeOnline/MeusAgendamentos/sxProps";
import { ProtocsSolicsBenef } from "../../../interfaces/entities/ProtocsSolicsBenef";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import ActivationGuideModal from "./ActivationGuideModal";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxPaginationContrast } from "../../../assets/styles/CommonSxProps";
import { scrollTo } from "../../../utils/ScrollUtil";
import PageTitle from "../../../components/Accessibility/PageTitle";

function AtivacaoDeGuia() {
    const [myGuides, setMyGuides] = useState<ProtocsSolicsBenef[]>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [name, setName] = useState<string>('');
    const [wallet, setWallet] = useState<string>('');
    const [protocol, setProtocol] = useState<string>('');
    const [open, setOpen] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);

    const accessibility = useAccessibility();

    useEffect(() => {
        const getMyGuides = async () => {
            const resultProcs = await getProtocsSolicsBenef();
            const resultBenef = await getBenef();

            if (resultProcs !== null && resultBenef !== null) {
                setName(`${resultBenef.nome} ${resultBenef.sobrenome}`)
                setWallet(resultBenef.login)
                setMyGuides(resultProcs.sort(sortByDate))
                setShowLoading(false);
            }
        }

        setShowLoading(true);
        getMyGuides();
    }, [reload]);

    const paginatedDoctors = myGuides.slice(
        (page - 1) * 5,
        page * 5
    );

    const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage);
        scrollTo('scroll-ref');
    };

    const handleGuideActivation = (idProtocol: string) => {
        setProtocol(idProtocol)
        setOpen(true);
    }

    const handleClose = (value: boolean) => {
        setProtocol('')
        setOpen(false);
        if (value) {
            setReload(!reload)
        }
    }

    const handleLoading = (value: boolean) => {
        setShowLoading(value)
    }

    const sortByDate = (a: ProtocsSolicsBenef, b: ProtocsSolicsBenef) => {
        let dataA = new Date(a.dtCriacao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
        let dataB = new Date(b.dtCriacao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
        return dataB - dataA;
    }

    return (
        <div className="my-guides-content">
            <LoadingApp showLoading={showLoading} />
            <div id='scroll-ref' />
            <PageTitle text="Ativação de guia futura" />
            <p className='my-guides-instructions' style={accessibility.textStyleAccessibilityWithMargin}>
               {`Ative a guia futura desejada com antecedência e verifique em Guias e autorizações > Minhas Guias a guia gerada e o seu status (aprovada ou em análise).`}
            </p>
            <p className='my-guides-instructions' style={accessibility.textStyleAccessibility}>
            A guia perderá a validade, a qualquer tempo, em caso de suspensão ou rompimento do contrato com a Unimed Campinas.
            </p>
            <h2 className="guide-activation-subtitle" style={accessibility.textStyleAccessibility}>Guias Futuras Disponíveis</h2>
            {myGuides.length === 0 &&
                <h1 className='empty-notifications-guide' style={accessibility.textStyleAccessibility}>Você não possui nenhuma guia futura para ativação disponível.</h1>
            }
            {myGuides.length > 0 &&
                <div className="doctors-cards-list">
                    {paginatedDoctors.map((guide, index) => (
                        <ActivationGuideCard guide={guide} key={`${guide.idSolic}-${index}`} name={name} wallet={wallet} handleGuideActivation={handleGuideActivation} handleLoading={handleLoading} />
                    ))}
                </div>
            }
            {myGuides.length > 5 &&
                <div className='pagination-holder'>
                    <Pagination
                        count={Math.ceil(myGuides.length / 5)}
                        sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
                        color='primary'
                        page={page}
                        onChange={handlePageChange}
                    />
                </div>
            }
            <ActivationGuideModal open={open} protocol={protocol} handleClose={handleClose} />
        </div>
    )
}

export default AtivacaoDeGuia;